/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { LocationDto } from './location.dto';

export const LocationMapper = entity<LocationDto>();
